export default __webpack_public_path__ + "static/media/cuentaClabe.55e55b5e.svg";